import React from 'react';

/**
 * Banda de cabecera de fases dentro del SVG del cuadro.
 * Cada columna queda alineada con su columna de partidos (mismo cx).
 */
export default function RoundHeaderBand({ columns, bandHeight, width }) {
  if (!Array.isArray(columns) || columns.length === 0 || !bandHeight) return null;

  const nameFont = Math.max(15, Math.round(bandHeight * 0.42));
  const countFont = Math.max(9, Math.round(bandHeight * 0.19));
  const fontFamily = "'DM Sans', 'Segoe UI', system-ui, sans-serif";

  return (
    <g className="bracket-round-band" aria-hidden>
      {columns.map((col, i) => (
        <g key={`round-head-${i}`}>
          <text
            x={col.cx}
            y={bandHeight * 0.42}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#f8fafc"
            fontWeight="800"
            fontSize={nameFont}
            fontFamily={fontFamily}
          >
            {col.name}
          </text>
          {col.total > 0 ? (
            <text
              x={col.cx}
              y={bandHeight * 0.79}
              textAnchor="middle"
              dominantBaseline="middle"
              fill="#7fa89a"
              fontWeight="700"
              fontSize={countFont}
              letterSpacing="0.14em"
              fontFamily={fontFamily}
            >
              {`${col.completed}/${col.total} JUGADOS`}
            </text>
          ) : null}
        </g>
      ))}
      <line
        x1={0}
        y1={bandHeight - 1}
        x2={width}
        y2={bandHeight - 1}
        stroke="rgba(227, 179, 65, 0.22)"
        strokeWidth={1}
      />
    </g>
  );
}
